/**
 * TPT Megamenu 2 JavaScript
 * Handles dropdown positioning, sticky functionality, dynamic border-radius, hamburger menu and mobile submenu (Updated)
 */

document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.tpt-megamenu-2__item-level--1');
    const menuContainer = document.querySelector('.tpt-megamenu-2-container');
    const menuNavbar = document.querySelector('.tpt-megamenu-2-navbar');
    const menuList = document.querySelector('.tpt-megamenu-2__list');
    let sectionWrapper = null;
    let originalNavbarParent = null;
    let originalNavbarNextSibling = null;
    let currentMobileMenu = null;
    let hamburgerTrigger = null;
    
    // Find the Shopify section wrapper
    if (menuContainer && menuContainer.dataset.sectionId) {
        sectionWrapper = document.getElementById(`shopify-section-${menuContainer.dataset.sectionId}`);
        // Store original navbar parent and position for potential restoration
        if (menuNavbar) {
            originalNavbarParent = menuNavbar.parentNode;
            originalNavbarNextSibling = menuNavbar.nextElementSibling;
        }
    }
    
    let resizeTimeout;
    let stickyObserver = null;
    
    // Mobile detection
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Check if layout is horizontal - Updated to check grid elements instead of container
    function isHorizontalLayout(menuItem = null) {
        if (menuItem) {
            // Check the specific menu item's dropdown for horizontal layout
            const dropdown = menuItem.querySelector('.tpt-megamenu-2__dropdown');
            if (dropdown) {
                const horizontalGrid = dropdown.querySelector('.tpt-megamenu__grid.tpt-horizontal-menu');
                return !!horizontalGrid;
            }
        }
        
        // Fallback: check if any grid has horizontal layout
        const horizontalGrid = document.querySelector('.tpt-megamenu__grid.tpt-horizontal-menu');
        return !!horizontalGrid;
    }

    /**
     * Calculate and set dynamic border-radius based on list height
     */
    function setDynamicBorderRadius() {
        if (!menuList) return;
        
        // On mobile, always set border-radius to 0
        if (isMobile()) {
            if (menuContainer) {
                menuContainer.style.setProperty('--dynamic-border-radius', '0px');
            }
            document.documentElement.style.setProperty('--dynamic-border-radius', '0px');
            return;
        }
        
        // Get the computed height of the menu list
        const listHeight = menuList.offsetHeight;
        
        // Calculate 50% of the height for border-radius
        const dynamicRadius = Math.round(listHeight * 0.5);
        
        // Set the CSS custom property on the container
        if (menuContainer) {
            menuContainer.style.setProperty('--dynamic-border-radius', `${dynamicRadius}px`);
        }
        
        // Also set it on the document root for global access
        document.documentElement.style.setProperty('--dynamic-border-radius', `${dynamicRadius}px`);
        
        console.log(`TPT Megamenu 2: Set dynamic border-radius to ${dynamicRadius}px (50% of list height: ${listHeight}px)`);
    }

    /**
     * Create hamburger icon and add to menu
     */
    function createHamburgerIcon() {
        // Remove existing hamburger if present
        const existingHamburger = document.querySelector('.tpt-megamenu-2__hamburger-trigger');
        if (existingHamburger) {
            existingHamburger.remove();
        }

        // Create hamburger trigger
        hamburgerTrigger = document.createElement('div');
        hamburgerTrigger.className = 'tpt-megamenu-2__hamburger-trigger';
        
        hamburgerTrigger.innerHTML = `
            <button type="button" class="tpt-megamenu-2__hamburger-button" aria-label="Open mobile menu">
                <div class="tpt-megamenu-2__hamburger-icon">
                    <div class="tpt-megamenu-2__hamburger-line"></div>
                    <div class="tpt-megamenu-2__hamburger-line"></div>
                    <div class="tpt-megamenu-2__hamburger-line"></div>
                </div>
            </button>
        `;

        // Add click handler
        const hamburgerButton = hamburgerTrigger.querySelector('.tpt-megamenu-2__hamburger-button');
        hamburgerButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            openMobileMenu();
        });

        // Insert into the menu list
        if (menuList) {
            menuList.appendChild(hamburgerTrigger);
        }

        return hamburgerTrigger;
    }

    /**
     * Initialize dynamic border-radius with a small delay to ensure elements are rendered
     */
    function initializeDynamicBorderRadius() {
        // Set initial border-radius
        setTimeout(() => {
            setDynamicBorderRadius();
        }, 100);
        
        // Also set it after a longer delay to catch any late-rendering elements
        setTimeout(() => {
            setDynamicBorderRadius();
        }, 500);
    }

    /**
     * Create mobile menu modal structure
     */
    function createMobileMenu() {
        if (document.querySelector('.tpt-megamenu-2__mobile-menu')) {
            return; // Already exists
        }

        const mobileMenu = document.createElement('div');
        mobileMenu.className = 'tpt-megamenu-2__mobile-menu';
        
        mobileMenu.innerHTML = `
            <div class="tpt-megamenu-2__mobile-overlay"></div>
            <div class="tpt-megamenu-2__mobile-panel tpt-megamenu">
                <div class="tpt-megamenu-2__mobile-header">
                    <h3 class="tpt-megamenu-2__mobile-title">Menu</h3>
                    <button type="button" class="tpt-megamenu-2__mobile-close" aria-label="Close mobile menu">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div class="tpt-megamenu-2__mobile-content">
                    <!-- Content will be populated by JavaScript -->
                </div>
            </div>
        `;

        document.body.appendChild(mobileMenu);

        // Setup event listeners
        const overlay = mobileMenu.querySelector('.tpt-megamenu-2__mobile-overlay');
        const closeBtn = mobileMenu.querySelector('.tpt-megamenu-2__mobile-close');

        overlay.addEventListener('click', closeMobileMenu);
        closeBtn.addEventListener('click', closeMobileMenu);

        // Close on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
                closeMobileMenu();
            }
        });

        return mobileMenu;
    }

    /**
     * Toggle mobile submenu with smooth animation (Accordion behavior - only one open at a time)
     */
    function toggleMobileSubmenu(menuItem) {
        const submenu = menuItem.querySelector('.tpt-megamenu-2__mobile-submenu');
        const arrow = menuItem.querySelector('.tpt-megamenu-2__mobile-menu-arrow');
        const menuLink = menuItem.querySelector('.tpt-megamenu-2__mobile-menu-link');
        
        if (!submenu) return;

        // Check if this submenu is currently expanded
        const isExpanded = submenu.classList.contains('expanded');
        
        // Close all other expanded submenus first (accordion behavior)
        const allMenuItems = document.querySelectorAll('.tpt-megamenu-2__mobile-menu-item');
        allMenuItems.forEach(item => {
            if (item !== menuItem) {
                const otherSubmenu = item.querySelector('.tpt-megamenu-2__mobile-submenu');
                const otherMenuLink = item.querySelector('.tpt-megamenu-2__mobile-menu-link');
                
                if (otherSubmenu && otherSubmenu.classList.contains('expanded')) {
                    item.classList.remove('expanded');
                    otherSubmenu.classList.remove('expanded');
                    
                    // Update aria-expanded for accessibility
                    if (otherMenuLink) {
                        otherMenuLink.setAttribute('aria-expanded', 'false');
                    }
                }
            }
        });
        
        // Now toggle the current submenu
        if (isExpanded) {
            // Collapse current
            menuItem.classList.remove('expanded');
            submenu.classList.remove('expanded');
            
            // Update aria-expanded for accessibility
            if (menuLink) {
                menuLink.setAttribute('aria-expanded', 'false');
            }
        } else {
            // Expand current
            menuItem.classList.add('expanded');
            submenu.classList.add('expanded');
            
            // Update aria-expanded for accessibility
            if (menuLink) {
                menuLink.setAttribute('aria-expanded', 'true');
            }
        }
    }

    /**
     * Populate mobile menu with menu items and prepare for animation
     */
    function populateMobileMenu(mobileMenu) {
        const content = mobileMenu.querySelector('.tpt-megamenu-2__mobile-content');
        if (!content) return;

        // Clear existing content
        content.innerHTML = '';

        // Get all menu items from the main navigation
        const currentMenuItems = document.querySelectorAll('.tpt-megamenu-2__item-level--1');
        
        currentMenuItems.forEach((item, index) => {
            const menuTitle = item.dataset.menuTitle || item.querySelector('.tpt-megamenu-2__item-level--1__text')?.textContent?.trim() || 'Menu Item';
            const dropdown = item.querySelector('.tpt-megamenu-2__dropdown');
            const originalLink = item.querySelector('a.tpt-megamenu-2__item-link');
            
            // Check if this item has dropdown content
            const hasDropdownContent = dropdown && (
                dropdown.querySelector('.tpt-megamenu__grid') || 
                dropdown.innerHTML.trim() !== ''
            );

            // Create mobile menu item
            const mobileMenuItem = document.createElement('div');
            mobileMenuItem.className = 'tpt-megamenu-2__mobile-menu-item';

            if (hasDropdownContent) {
                // Item with dropdown - make it clickable to show/hide submenu
                const menuLink = document.createElement('div');
                menuLink.className = 'tpt-megamenu-2__mobile-menu-link';
                menuLink.innerHTML = `
                    <span class="tpt-megamenu-2__mobile-menu-text">${menuTitle}</span>
                    <svg class="tpt-megamenu-2__mobile-menu-arrow" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `;

                // Create submenu container
                const submenu = document.createElement('div');
                submenu.className = 'tpt-megamenu-2__mobile-submenu';
                
                const submenuContent = document.createElement('div');
                submenuContent.className = 'tpt-megamenu-2__mobile-submenu-content';
                
                // Clone the dropdown content for the submenu
                const dropdownClone = dropdown.cloneNode(true);
                dropdownClone.style.cssText = '';
                dropdownClone.classList.add('tpt-megamenu-2__mobile-dropdown-clone');
                
                // Remove dropdown-specific positioning classes
                dropdownClone.classList.remove(
                    'tpt-megamenu-2__dropdown--shifted',
                    'tpt-megamenu-2__dropdown--right-aligned',
                    'tpt-megamenu-2__dropdown--centered',
                    'tpt-megamenu-2__dropdown--constrained'
                );
                
                submenuContent.appendChild(dropdownClone);
                submenu.appendChild(submenuContent);

                // Add click handler for dropdown items to toggle submenu
                menuLink.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleMobileSubmenu(mobileMenuItem);
                });

                // Keyboard support
                menuLink.addEventListener('keydown', function(e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleMobileSubmenu(mobileMenuItem);
                    }
                });

                // Set up accessibility
                menuLink.setAttribute('role', 'button');
                menuLink.setAttribute('aria-expanded', 'false');
                menuLink.setAttribute('tabindex', '0');

                mobileMenuItem.appendChild(menuLink);
                mobileMenuItem.appendChild(submenu);
            } else {
                // Simple link item
                const menuLink = document.createElement('a');
                menuLink.className = 'tpt-megamenu-2__mobile-menu-link';
                menuLink.href = originalLink ? originalLink.href : '#';
                menuLink.innerHTML = `
                    <span class="tpt-megamenu-2__mobile-menu-text">${menuTitle}</span>
                `;

                // Close mobile menu when clicking a link
                menuLink.addEventListener('click', function() {
                    closeMobileMenu();
                });

                mobileMenuItem.appendChild(menuLink);
            }

            content.appendChild(mobileMenuItem);
        });
    }

    /**
     * Open mobile menu with smooth content animation
     */
    function openMobileMenu() {
        if (!isMobile()) return;

        const mobileMenu = document.querySelector('.tpt-megamenu-2__mobile-menu');
        if (!mobileMenu) {
            console.warn('TPT Megamenu 2: Mobile menu not found. Make sure createMobileMenu() was called during initialization.');
            return;
        }

        // Populate with current menu items
        populateMobileMenu(mobileMenu);

        // Store current modal reference
        currentMobileMenu = mobileMenu;

        // Prevent body scroll
        document.body.classList.add('tpt-mobile-menu-open');
        document.body.style.overflow = 'hidden';

        // Show modal with staggered animation
        mobileMenu.classList.add('active');

        // Focus management for accessibility - delay to allow animation to complete
        setTimeout(() => {
            const closeBtn = mobileMenu.querySelector('.tpt-megamenu-2__mobile-close');
            if (closeBtn) {
                closeBtn.focus();
            }
        }, 600); // Increased delay to account for content animation
    }

    /**
     * Close mobile menu with proper cleanup
     */
    function closeMobileMenu() {
        if (!currentMobileMenu) return;

        // Remove active class to trigger close animation
        currentMobileMenu.classList.remove('active');

        // Restore body scroll after animation completes
        setTimeout(() => {
            document.body.classList.remove('tpt-mobile-menu-open');
            document.body.style.overflow = '';
        }, 400); // Match panel close animation duration

        // Clear current modal reference
        currentMobileMenu = null;
    }

    // Initialize sticky menu functionality
    if (menuContainer && sectionWrapper && menuContainer.dataset.stickyMenu === 'true') {
        initializeStickyMenu();
    }
    
    // Initialize dynamic border-radius
    initializeDynamicBorderRadius();
    
    // Initialize functionality for each menu item
    menuItems.forEach(item => {
        const dropdown = item.querySelector('.tpt-megamenu-2__dropdown');
        if (!dropdown) return;
        
        // Desktop hover functionality
        if (!isMobile()) {
            setupDesktopEvents(item, dropdown);
        }
    });

    // Create hamburger menu
    createHamburgerIcon();

    // Create mobile menu on DOM load
    createMobileMenu();

    /**
     * Initialize sticky menu functionality
     */
    function initializeStickyMenu() {
        // Check if menu should be moved to header
        if (menuContainer.dataset.moveToHeader === 'true') {
            moveNavbarToHeader();
        } else {
            // Apply sticky attributes to the section wrapper
            sectionWrapper.setAttribute('data-sticky-enabled', 'true');
            
            // Copy CSS variables from menu container to section wrapper
            const stickyZIndex = menuContainer.style.getPropertyValue('--sticky-z-index') || '10';
            sectionWrapper.style.setProperty('--sticky-z-index', stickyZIndex);
        }
    }

    /**
     * Move only the megamenu navbar to header element
     */
    function moveNavbarToHeader() {
        if (!menuNavbar) {
            console.warn('TPT Megamenu 2: Navbar element not found');
            return;
        }

        let headerElement = null;
        
        // Try to find header element using custom class or default <header> tag
        if (menuContainer.dataset.headerClass) {
            headerElement = document.querySelector(`.${menuContainer.dataset.headerClass}`);
        }
        
        // Fallback to <header> tag if custom class not found or not specified
        if (!headerElement) {
            headerElement = document.querySelector('header');
        }
        
        if (headerElement) {
            // Create a wrapper for the navbar in the header to maintain styling
            const headerNavWrapper = document.createElement('div');
            headerNavWrapper.className = 'tpt-megamenu-2-header-wrapper';
            headerNavWrapper.style.cssText = `
                background-color: ${menuContainer.style.getPropertyValue('--container-background-color') || 'var(--container-background-color, transparent)'};
                border-width: ${menuContainer.style.getPropertyValue('--container-border-width') || 'var(--container-border-width, 0px)'};
                border-style: ${menuContainer.style.getPropertyValue('--container-border-style') || 'var(--container-border-style, solid)'};
                border-color: ${menuContainer.style.getPropertyValue('--container-border-color') || 'var(--container-border-color, #e0e0e0)'};
                border-radius: ${menuContainer.style.getPropertyValue('--container-border-radius') || 'var(--container-border-radius, 0px)'};
                padding: ${menuContainer.style.getPropertyValue('--container-padding-vertical') || 'var(--container-padding-vertical, 0px)'} ${menuContainer.style.getPropertyValue('--container-padding-horizontal') || 'var(--container-padding-horizontal, 0px)'};
                box-sizing: border-box;
            `;
            
            // Copy all CSS custom properties from the original container
            const computedStyle = window.getComputedStyle(menuContainer);
            const cssVars = Array.from(document.documentElement.style).filter(prop => prop.startsWith('--'));
            cssVars.forEach(prop => {
                const value = menuContainer.style.getPropertyValue(prop);
                if (value) {
                    headerNavWrapper.style.setProperty(prop, value);
                }
            });
            
            // Also copy inline CSS variables
            if (menuContainer.getAttribute('style')) {
                const inlineStyles = menuContainer.getAttribute('style');
                const vars = inlineStyles.match(/--[^;]+;?/g) || [];
                vars.forEach(varDecl => {
                    headerNavWrapper.style.cssText += varDecl;
                });
            }
            
            // Move only the navbar to the header wrapper
            headerNavWrapper.appendChild(menuNavbar);
            headerElement.appendChild(headerNavWrapper);
            
            // Apply sticky properties to the header
            headerElement.setAttribute('data-tpt-megamenu-moved', 'true');
            
            // Copy CSS variables for z-index
            const stickyZIndex = menuContainer.style.getPropertyValue('--sticky-z-index') || '10';
            headerElement.style.setProperty('--tpt-megamenu-z-index', stickyZIndex);
            headerNavWrapper.style.setProperty('--sticky-z-index', stickyZIndex);
            
            // Ensure dropdowns have proper z-index when in header
            headerNavWrapper.style.setProperty('--dropdown-z-index', `calc(${stickyZIndex} + 1)`);
            
            console.log('TPT Megamenu 2: Successfully moved navbar to header element');
            
            // Recalculate border-radius after moving to header
            setTimeout(() => {
                setDynamicBorderRadius();
            }, 100);
            
            // Re-create hamburger in new location
            createHamburgerIcon();
            
        } else {
            // Header not found, log warning and fallback to original behavior
            console.warn('TPT Megamenu 2: Header element not found. Menu will remain in original position.');
            
            // Fallback to original sticky behavior
            sectionWrapper.setAttribute('data-sticky-enabled', 'true');
            const stickyZIndex = menuContainer.style.getPropertyValue('--sticky-z-index') || '10';
            sectionWrapper.style.setProperty('--sticky-z-index', stickyZIndex);
        }
    }

    /**
     * Restore navbar to original position (if needed)
     */
    function restoreNavbarToOriginalPosition() {
        if (!originalNavbarParent || !menuNavbar) return;
        
        const currentHeaderWrapper = menuNavbar.closest('.tpt-megamenu-2-header-wrapper');
        const currentHeader = menuNavbar.closest('header, [data-tpt-megamenu-moved]');
        
        if (currentHeaderWrapper && currentHeader && menuNavbar.parentNode !== originalNavbarParent) {
            // Remove attributes from header
            currentHeader.removeAttribute('data-tpt-megamenu-moved');
            currentHeader.style.removeProperty('--tpt-megamenu-z-index');
            
            // Move navbar back to original position
            if (originalNavbarNextSibling) {
                originalNavbarParent.insertBefore(menuNavbar, originalNavbarNextSibling);
            } else {
                originalNavbarParent.appendChild(menuNavbar);
            }
            
            // Remove the header wrapper
            if (currentHeaderWrapper.parentNode) {
                currentHeaderWrapper.parentNode.removeChild(currentHeaderWrapper);
            }
            
            // Show the section wrapper again
            if (sectionWrapper) {
                sectionWrapper.style.display = '';
            }
            
            console.log('TPT Megamenu 2: Restored navbar to original position');
            
            // Recalculate border-radius after restoring
            setTimeout(() => {
                setDynamicBorderRadius();
            }, 100);

            // Re-create hamburger in original location
            createHamburgerIcon();
        }
    }

    /**
     * Debounce function to limit function calls
     */
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    
    /**
     * Setup desktop hover events
     */
    function setupDesktopEvents(item, dropdown) {
        // Position dropdown on hover
        item.addEventListener('mouseenter', function() {
            if (isMobile()) return;
            
            // Small delay to ensure dropdown is visible for measurement
            setTimeout(() => {
                positionDropdown(item, dropdown);
            }, 10);
        });
        
        // Reset positioning when hover ends - Skip for horizontal layout
        item.addEventListener('mouseleave', function() {
            if (isMobile()) return;
            
            // Skip reset for horizontal layout - now checking specific menu item
            if (isHorizontalLayout(item)) return;
            
            resetDropdownPosition(dropdown);
        });
    }
    
    /**
     * Position dropdown to prevent overflow (Desktop only)
     * @param {Element} menuItem - The menu item element
     * @param {Element} dropdown - The dropdown element
     */
    function positionDropdown(menuItem, dropdown) {
        if (isMobile()) return;
        
        // Skip positioning for horizontal layout - now checking specific menu item
        if (isHorizontalLayout(menuItem)) return;
        
        // Reset any previous positioning
        resetDropdownPosition(dropdown);
        
        // Get viewport dimensions
        const viewportWidth = window.innerWidth;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const effectiveViewportWidth = viewportWidth - scrollbarWidth;
        
        // Get positions and dimensions
        const menuItemRect = menuItem.getBoundingClientRect();
        const dropdownRect = dropdown.getBoundingClientRect();
        const dropdownWidth = dropdownRect.width;
        
        // Calculate potential overflow
        const rightEdge = menuItemRect.left + dropdownWidth;
        const leftEdge = menuItemRect.left;
        
        // Add safety margins
        const rightMargin = 20;
        const leftMargin = 20;
        
        // Check for right edge overflow
        if (rightEdge > (effectiveViewportWidth - rightMargin)) {
            // Calculate how much we need to shift left
            const overflow = rightEdge - (effectiveViewportWidth - rightMargin);
            const shiftLeft = Math.min(overflow, menuItemRect.right - dropdownWidth - leftMargin);
            
            if (shiftLeft > 0) {
                dropdown.style.left = `${-shiftLeft}px`;
                dropdown.classList.add('tpt-megamenu-2__dropdown--shifted');
            } else {
                // If we can't shift enough, align to right edge of menu item
                dropdown.style.left = 'auto';
                dropdown.style.right = '0';
                dropdown.classList.add('tpt-megamenu-2__dropdown--right-aligned');
            }
        }
        
        // Check for left edge overflow after right alignment
        const currentDropdownRect = dropdown.getBoundingClientRect();
        if (currentDropdownRect.left < leftMargin) {
            // Reset and try centering approach
            resetDropdownPosition(dropdown);
            
            const availableWidth = effectiveViewportWidth - leftMargin - rightMargin;
            const centerPosition = (effectiveViewportWidth / 2) - (dropdownWidth / 2) - menuItemRect.left;
            
            // Ensure dropdown doesn't exceed available space
            if (dropdownWidth <= availableWidth) {
                dropdown.style.left = `${Math.max(-menuItemRect.left + leftMargin, centerPosition)}px`;
                dropdown.classList.add('tpt-megamenu-2__dropdown--centered');
            } else {
                // As last resort, constrain width and center
                dropdown.style.left = `${-menuItemRect.left + leftMargin}px`;
                dropdown.style.maxWidth = `${availableWidth}px`;
                dropdown.classList.add('tpt-megamenu-2__dropdown--constrained');
            }
        }
    }
    
    /**
     * Reset dropdown to default position
     * @param {Element} dropdown - The dropdown element
     */
    function resetDropdownPosition(dropdown) {
        // Skip reset for horizontal layout - need to check parent menu item
        const menuItem = dropdown.closest('.tpt-megamenu-2__item-level--1');
        if (isHorizontalLayout(menuItem)) return;
        
        dropdown.style.left = '';
        dropdown.style.right = '';
        dropdown.style.maxWidth = '';
        dropdown.classList.remove(
            'tpt-megamenu-2__dropdown--shifted',
            'tpt-megamenu-2__dropdown--right-aligned',
            'tpt-megamenu-2__dropdown--centered',
            'tpt-megamenu-2__dropdown--constrained'
        );
    }
    
    /**
     * Recalculate positions on window resize
     */
    function handleResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Close mobile menu on resize if open
            if (currentMobileMenu) {
                closeMobileMenu();
            }

            // Recalculate dynamic border-radius on resize
            setDynamicBorderRadius();
            
            // Find currently visible dropdowns and reposition them (desktop only)
            if (!isMobile()) {
                const visibleDropdowns = document.querySelectorAll('.tpt-megamenu-2__item-level--1:hover .tpt-megamenu-2__dropdown');
                visibleDropdowns.forEach(dropdown => {
                    const menuItem = dropdown.closest('.tpt-megamenu-2__item-level--1');
                    if (menuItem && !isHorizontalLayout(menuItem)) {
                        positionDropdown(menuItem, dropdown);
                    }
                });
            }
            
            // Re-setup events based on new screen size - get current menu items from wherever they are
            const currentMenuItems = document.querySelectorAll('.tpt-megamenu-2__item-level--1');
            currentMenuItems.forEach(item => {
                const dropdown = item.querySelector('.tpt-megamenu-2__dropdown');
                if (!dropdown) return;
                
                // Remove all existing event listeners by cloning and replacing
                const newItem = item.cloneNode(true);
                item.parentNode.replaceChild(newItem, item);
                
                // Re-setup events for desktop only
                if (!isMobile()) {
                    setupDesktopEvents(newItem, newItem.querySelector('.tpt-megamenu-2__dropdown'));
                }
            });

            // Re-create hamburger icon after resize
            createHamburgerIcon();

            // Handle header movement on resize if needed
            if (menuContainer && menuContainer.dataset.moveToHeader === 'true') {
                // Check if we need to move or restore based on current state
                const isInHeader = !!menuNavbar && !!menuNavbar.closest('header, [data-tpt-megamenu-moved]');
                const shouldBeInHeader = true; // Based on settings, always true if moveToHeader is set
                
                if (shouldBeInHeader && !isInHeader) {
                    moveNavbarToHeader();
                } else if (!shouldBeInHeader && isInHeader) {
                    restoreNavbarToOriginalPosition();
                }
            }
        }, 100);
    }
    
    window.addEventListener('resize', handleResize);
    
    window.addEventListener('orientationchange', () => {
        setTimeout(() => {
            // Close mobile menu on orientation change
            if (currentMobileMenu) {
                closeMobileMenu();
            }
            
            handleResize();
            // Additional delay for orientation change
            setTimeout(() => {
                setDynamicBorderRadius();
                createHamburgerIcon();
            }, 300);
        }, 500);
    });

    // Close mobile menu when clicking outside menu area on mobile
    document.addEventListener('click', function(e) {
        if (isMobile() && currentMobileMenu && !e.target.closest('.tpt-megamenu-2')) {
            // Don't close if clicking on mobile menu content
            if (!e.target.closest('.tpt-megamenu-2__mobile-panel')) {
                closeMobileMenu();
            }
        }
    });
    
    // Handle keyboard navigation for accessibility
    function updateMenuItemsAccessibility() {
        const currentMenuItems = document.querySelectorAll('.tpt-megamenu-2__item-level--1');
        currentMenuItems.forEach(item => {
            const itemLabel = item.querySelector('.tpt-megamenu-2__item-label');
            if (itemLabel && !itemLabel.hasAttribute('data-accessibility-setup')) {
                // Make it focusable
                itemLabel.setAttribute('tabindex', '0');
                itemLabel.setAttribute('role', 'button');
                itemLabel.setAttribute('aria-haspopup', 'true');
                itemLabel.setAttribute('aria-expanded', 'false');
                itemLabel.setAttribute('data-accessibility-setup', 'true');
            }
        });
    }

    // Initialize accessibility
    updateMenuItemsAccessibility();

    // Recalculate border-radius when fonts are loaded (can affect height)
    if (document.fonts) {
        document.fonts.ready.then(() => {
            setTimeout(() => {
                setDynamicBorderRadius();
            }, 100);
        });
    }

    // Clean up observers on page unload
    window.addEventListener('beforeunload', function() {
        if (stickyObserver) {
            stickyObserver.disconnect();
        }
    });

    // Expose functions globally for potential external calls
    window.tptMegamenu2SetDynamicBorderRadius = setDynamicBorderRadius;
    window.tptMegamenu2OpenMobileMenu = openMobileMenu;
    window.tptMegamenu2CloseMobileMenu = closeMobileMenu;
    window.tptMegamenu2CreateHamburgerIcon = createHamburgerIcon;
});

/**
 * Utility function to check if element is in viewport
 * @param {Element} element - Element to check
 * @returns {boolean} - Whether element is fully in viewport
 */
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.left >= 0 &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientWidth)
    );
}